import Vue from "vue"

// 全局打印配置
const printConfig = {
  showPrintLogo: false, // 打印单据是否显示logo
}

Vue.mixin({
  computed: {
    showPrintLogo() {
      return printConfig.showPrintLogo
    }
  },
  methods: {
    hasAuth(perm) {
      let authority = this.$store.state.user.perms
      return authority.indexOf(perm) > -1
    }
  }
})



// WEBPACK FOOTER //
// ./src/globalFun.js